import { render, staticRenderFns } from "./BtnSelecionarCliente.vue?vue&type=template&id=70866d65&"
import script from "./BtnSelecionarCliente.vue?vue&type=script&lang=js&"
export * from "./BtnSelecionarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports